import { ExternalUrlRouter } from 'components/pages/ExternalUrlRouter/ExternalUrlRouter';

export const routerConfig = [
  {
    path: '/external-service-:serviceType',
    name: 'External Router',
    exact: true,
    component: ExternalUrlRouter,
    external: true,
    requestStates: []
  }
];
